module.exports = __webpack_public_path__ + "static/media/1007099.c69d63e2.png";